import type BaseEnumType from "@/app/services/baseEnumType";
import type { Maybe } from "@/components/utils/typeHelpers";

export class EnumChangelogEntryType implements BaseEnumType {
  private static allValues: EnumChangelogEntryType[] = []; // make sure this is top-most

  public static bug = new EnumChangelogEntryType(
    1,
    "Bug",
    "enum_changelog_entry_type_bug"
  );
  public static minor = new EnumChangelogEntryType(
    2,
    "Minor",
    "enum_changelog_entry_type_minor"
  );
  public static major = new EnumChangelogEntryType(
    3,
    "Major",
    "enum_changelog_entry_type_major"
  );

  public key: number;
  public value: string;
  public translationKey?: string;

  private constructor(key: number, value: string, translationKey?: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumChangelogEntryType.allValues.push(this);
  }

  public equals(other: Maybe<EnumChangelogEntryType>): boolean {
    return this.key === other?.key;
  }

  public isBug() {
    return this.equals(EnumChangelogEntryType.bug);
  }
  public isMinor() {
    return this.equals(EnumChangelogEntryType.minor);
  }
  public isMajor() {
    return this.equals(EnumChangelogEntryType.major);
  }

  public static getValues(): EnumChangelogEntryType[] {
    return EnumChangelogEntryType.allValues;
  }

  public static getByKey(key: number): EnumChangelogEntryType {
    const found = EnumChangelogEntryType.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumChangelogEntryType - Key not found: ${key}`);
    }

    return found;
  }
}
